import { cx } from '@emotion/css';

import { Accordion } from '@phoenix/design-system/frontend/ui/accordion/accordion';
import { Dealer } from '../dealer.types';
import { useDealerOpeningHours } from '../hooks/use-dealer-opening-hours.hook';
import { DealerOpeningHours } from './dealer-opening-hours';
import { useGtmTracking } from '../hooks/use-gtm-tracking';

const DealerOpeningHoursHeader = ({ dealer }: { dealer: Dealer }) => {
  const { trackPromotion } = useGtmTracking();

  const { openingHoursForToday, openingHoursCurrentlyOpen, openingHoursStatusLabel } = useDealerOpeningHours(
    dealer.openingHours,
    dealer.isOpen
  );

  return (
    <div
      className="flex stihl-text-body-default-reg desktop:flex-row desktop:items-center pt-2"
      onClick={() => trackPromotion(dealer, 'opening-hours')}
    >
      <div className="mt-1 w-8">
        <div className={cx('h-4 w-4 flex-shrink-0 rounded-full', openingHoursCurrentlyOpen ? 'bg-green' : 'bg-red')} />
      </div>
      <div className="flex flex-col flex-wrap desktop:flex-row desktop:space-x-4">
        <div className="flex-shrink-0 stihl-text-body-default-bold">{openingHoursStatusLabel}</div>
        {/* eslint-disable-next-line react/no-danger */}
        {openingHoursForToday && <div className="flex-shrink-0 pe-4" dangerouslySetInnerHTML={{ __html: openingHoursForToday }} />}
      </div>
    </div>
  );
};

const OpeningHoursAccordion = ({ dealer, openingHoursInitiallyExpanded }: { dealer?: Dealer; openingHoursInitiallyExpanded?: boolean }) => {
  if (!dealer || Object.keys(dealer.openingHours || {})?.length === 0) {
    return null;
  }

  return (
    <Accordion
      title={<DealerOpeningHoursHeader dealer={dealer} />}
      data-testid="dealer-details_accordion-opening-hours"
      defaultIsOpen={openingHoursInitiallyExpanded}
      contentPadding="!pt-0 !pb-2"
    >
      <DealerOpeningHours dealer={dealer} dataTestId="dealer-details_accordion-opening-hours-details" />
    </Accordion>
  );
};

export { OpeningHoursAccordion };
